export const handleDateRangeChange = (value, setStartDate, setEndDate) => {
  const today = new Date();
  let startDate, endDate;

  switch (value) {
    case "1d":
      startDate = new Date(today.setDate(today.getDate() - 1))
        .toISOString()
        .split("T")[0];
      endDate = new Date().toISOString().split("T")[0];
      break;
    case "3d":
      startDate = new Date(today.setDate(today.getDate() - 3))
        .toISOString()
        .split("T")[0];
      endDate = new Date().toISOString().split("T")[0];
      break;
    case "3m":
      startDate = new Date(today.setMonth(today.getMonth() - 3))
        .toISOString()
        .split("T")[0];
      endDate = new Date().toISOString().split("T")[0];
      break;
    case "1y":
      startDate = new Date(today.setFullYear(today.getFullYear() - 1))
        .toISOString()
        .split("T")[0];
      endDate = new Date().toISOString().split("T")[0];
      break;
    default:
      startDate = null;
      endDate = null;
  }

  setStartDate(startDate);
  setEndDate(endDate);
};

export const copyTextToClipboard = (text) => {
  // Create a temporary textarea element
  const textarea = document.createElement("textarea");

  // Set the text value to be copied
  textarea.value = text;

  // Append it to the body (it's not visible to the user)
  document.body.appendChild(textarea);

  // Select the text
  textarea.select();

  // Execute the 'copy' command
  document.execCommand("copy");

  // Remove the temporary textarea from the DOM
  document.body.removeChild(textarea);
};
